import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callPost } from "../../http_client";

import {
  bookingsFetchError,
  bookingsFetchRequest,
  bookingsFetchSuccess,
  flightsFetchError,
  flightsFetchRequest,
  flightsFetchSuccess,
} from "./actions";
import { GateTesterActionTypes } from "./types";

export function* handleFlightsFetch(action: ReturnType<typeof flightsFetchRequest>): SagaIterator {
  try {
    const {
      departureDate,
      returnDate,
      adultsPassengers,
      childrenPassengers,
      infantsPassengers,
      ...other
    } = action.payload;
    const payload = {
      departureDate: departureDate.format("YYYY-MM-DD"),
      returnDate: returnDate?.format("YYYY-MM-DD"),
      adults: adultsPassengers,
      children: childrenPassengers,
      infants: infantsPassengers,
      ...other,
    };
    const res = yield call(callPost, "/gate_tester/api/", payload);
    yield put(flightsFetchSuccess(res.data));
  } catch (err) {
    yield put(flightsFetchError(err.response.data));
  }
}

export function* handleBookingsFetch(action: ReturnType<typeof bookingsFetchRequest>): SagaIterator {
  try {
    const { dateFrom, dateTo, ...other } = action.payload;
    const payload = {
      dateFrom: dateFrom.format("YYYY-MM-DD"),
      dateTo: dateTo?.format("YYYY-MM-DD"),
      ...other,
    };
    const res = yield call(callPost, "/gate_tester/bookings/", payload);
    yield put(bookingsFetchSuccess(res.data));
  } catch (err) {
    yield put(bookingsFetchError(err.response.data));
  }
}

function* watchGateTesterSagas(): SagaIterator {
  yield takeLatest(GateTesterActionTypes.FLIGHTS_FETCH_REQUEST, handleFlightsFetch);
  yield takeLatest(GateTesterActionTypes.BOOKINGS_FETCH_REQUEST, handleBookingsFetch);
}

export default watchGateTesterSagas;
